module.exports = __webpack_public_path__ + "static/media/work1.2.d47bbb63.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/work1.2.webp
// module id = 521
// module chunks = 4